module.exports = __webpack_public_path__ + "img/bus-service-icon3.aafb7351.png";